import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistAllWorkItemsRequest } from './request';
import { artistAllWorkItems } from './request';

export const useArtistAllWorkItemsQuery = (
  params: ArtistAllWorkItemsRequest,
  settings?: QuerySettings<typeof artistAllWorkItems>
) =>
  useQuery({
    queryKey: ['ArtistAllWorkItems', params.profileId],
    queryFn: () =>
      artistAllWorkItems({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
